import React from 'react';
import AllProjectDonutChart from './AllProjectDonutChart';
import { SVGICON } from '../../../constant/theme';
import ReactApexChart from "react-apexcharts";
import { Link } from 'react-router-dom';

const LoadingCompo = () => {
    return (
        <div style={{ height: "20rem" }} className='d-flex justify-content-center align-items-center flex-column'>
            <div className="spinner-grow text-primary" style={{ height: "5rem", width: "5rem" }} role="status">
            </div>
            <span className="">Loading...</span>
        </div>)
}

const SmallStatCard = ({ title, value }) => (
    <div className="col-xl-2 col-md-3 col-sm-4 col-6">
        <div className="card p-2 text-center">
            <h6 className='mb-1 fs-6'>{title}</h6>
            <h5 className='mb-0 text-primary'>{value}</h5>
        </div>
    </div>
);

const CardWidget = ({ data }) => {

    return data === null ? <div className="row">
        <div className="col-xl-3 col-sm-6"><div className='card'><LoadingCompo /></div></div>
        <div className="col-xl-3 col-sm-6"><div className='card'><LoadingCompo /></div></div>
        <div className="col-xl-3 col-sm-6"><div className='card'><LoadingCompo /></div></div>
        <div className="col-xl-3 col-sm-6"><div className='card'><LoadingCompo /></div></div>
    </div> :
        <>
            <div className="row">
                <div className="col-xl-3 col-sm-6">
                    <div className="card">
                        <div className="card-body depostit-card">
                            <div className="depostit-card-media d-flex justify-content-between style-1">
                                <div>
                                    <h6>Today Stock IN</h6>
                                    <h3>{data.today_stock_in}</h3>
                                </div>
                                <div className="icon-box bg-success-light">
                                    <i className="fa-solid fa-cart-arrow-down fa-xl text-success"></i>
                                </div>
                            </div>
                            <div className="depostit-card-media d-flex justify-content-between style-1 mt-2">
                                <div>
                                    <h6>Today Stock OUT</h6>
                                    <h3>{data.today_stock_out}</h3>
                                </div>
                                <div className="icon-box bg-danger-light">
                                    <i className="fa-solid fa-square-up-right fa-xl text-danger"></i>
                                </div>
                            </div>

                            <div className="depostit-card-media d-flex justify-content-between style-1 mt-2 border-top pt-3 mb-2">
                                <div>
                                    <h6>Total Material</h6>
                                    <h3>{data.total_product}</h3>
                                </div>
                                <div className="icon-box bg-primary-light">
                                    {SVGICON.MenuMaterial}
                                </div>
                            </div>

                            <div className="depostit-card-media d-flex justify-content-between style-1">
                                <div>
                                    <h6>Perishable Material</h6>
                                    <h3>{data.total_perishable_product}</h3>
                                </div>
                                <div className="icon-box bg-secondary-light">
                                    {SVGICON.MenuPerishable}
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <div className="col-xl-3 col-sm-6">
                    <div className="card same-card">
                        <div className='d-flex align-items-center justify-content-between border-bottom px-3 py-2'>
                            <h5 className='mb-0'>Stock Summary</h5>
                            <Link to={'/material'} className='btn btn-sm btn-outline-primary'>View Materials</Link>
                        </div>
                        <div className="card-body d-flex align-items-center flex-column  py-3">
                            <AllProjectDonutChart series={[data.under_stock, data.over_stock, data.in_stock]} />

                            <ul className="project-list d-flex flex-wrap gap-2">
                                <li>
                                    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect width="10" height="10" rx="3" fill="#ff5e5e" />
                                    </svg>{" "}
                                    Under Stock
                                </li>
                                <li>
                                    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect width="10" height="10" rx="3" fill="#FF9F00" />
                                    </svg>{" "}
                                    Over Stock
                                </li>
                                <li>
                                    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect width="10" height="10" rx="3" fill="#3AC977" />
                                    </svg>{" "}
                                    In Stock
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="col-xl-3 col-sm-6">
                    <div className="card">
                        <div className='d-flex align-items-center justify-content-between border-bottom px-3 py-2'>
                            <h5 className='mb-0'>Perishable Stock</h5>
                            <Link to={"/perishable-stock"} className='btn btn-sm btn-outline-primary'>View Details</Link>
                        </div>
                        <div className="card-body depostit-card p-3">
                            <PerishableLineChart perishableStock={data?.perishable_stock} />
                        </div>
                    </div>
                </div>


                <div className="col-xl-3 col-sm-6 same-card">
                    <div className="card">
                        <div className='d-flex align-items-center justify-content-between border-bottom px-3 py-2'>
                            <h5 className='mb-0'>Inventory Transfers</h5>
                            <Link to={"/borrwed-lent-stock"} className='btn btn-sm btn-outline-primary'>View Details</Link>
                        </div>
                        <div className="card-body depostit-card">
                            <div>
                                <div className=''>
                                    <div className='d-flex justify-content-between align-items-center mb-2'>
                                        <span className='text-dark fs-6'>Borrowed Materials</span>
                                        <h4 className='text-secondary'>{data?.borrowed_lent_stock?.borrowed?.product_count}</h4>
                                    </div>
                                    <div className='d-flex justify-content-between align-items-center mb-2'>
                                        <span className='text-dark fs-6'>Borrowed Stocks </span>
                                        <h4 className='text-secondary'>{data?.borrowed_lent_stock?.borrowed?.total_quantity}</h4>
                                    </div>
                                </div>
                            </div>
                            <div className='pt-3 border-top mt-3'>
                                <div className='d-flex justify-content-between align-items-center mb-2'>
                                    <span className='text-dark fs-6'>Lent Materials</span>
                                    <h4 className='text-secondary'>{data?.borrowed_lent_stock?.lent?.product_count}</h4>
                                </div>
                                <div className='d-flex justify-content-between align-items-center mb-1'>
                                    <span className='text-dark fs-6'>Lent Stocks </span>
                                    <h4 className='text-secondary'>{data?.borrowed_lent_stock?.lent?.total_quantity}</h4>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-xl-4 mb-2 mb-xl-0">
                    <div className="card p-3">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <h5 className="mb-0">Reservation Summary</h5>
                            <Link to={"/reservation"} className="btn btn-sm btn-outline-primary">View</Link>
                        </div>
                        <div className="row">
                            <div className="col-6 col-sm-4">
                                <div className='border border-warning bg-warning-light rounded p-2 text-center '>
                                    <span className="text-warning fs-6 mb-0">
                                        <i className="fa-solid fa-hourglass-start me-2"></i> Pending</span>
                                    <h4 className='text-warning mb-0'>{data.reservation_stats?.pending || 0}</h4>
                                </div>
                            </div>
                            <div className="col-6 col-sm-4">
                                <div className='border border-success bg-success-light rounded p-2 text-center '>
                                    <span className="text-success fs-6 mb-0"><i className="fa-regular fa-circle-check me-2"></i>Fulfilled</span>
                                    <h4 className='text-success mb-0'>{data.reservation_stats?.fulfilled || 0}</h4>
                                </div>
                            </div>
                            <div className="col-6 col-sm-4">
                                <div className='border border-danger bg-danger-light rounded p-2 text-center '>
                                    <span className="text-danger fs-6 mb-0"><i className="fa-solid fa-triangle-exclamation me-2"></i>Canceled</span>
                                    <h4 className='text-danger mb-0'>{data.reservation_stats?.cancelled || 0}</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-xl-8">
                    <div className="card p-3">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <h5 className="mb-0">Requisition Summary</h5>
                            <Link to={"/requisition"} className="btn btn-sm btn-outline-primary">View</Link>
                        </div>
                        <div className="row mb-0">
                            <div className="col-6 col-sm-3">
                                <div className='border border-danger rounded p-2 text-center '>
                                    <span className="text-danger fs-6 mb-0">
                                        <i className="fa-solid fa-business-time me-2"></i> Overdue</span>
                                    <h4 className='text-danger mb-0'>{data.requisition_stats?.overdue || 0}</h4>
                                </div>
                            </div>
                            <div className="col-6 col-sm-3">
                                <div className='border border-warning rounded p-2 text-center '>
                                    <span className="text-warning fs-6 mb-0"><i className="fa-solid fa-hourglass-start me-2"></i> Total Pending</span>
                                    <h4 className='text-warning mb-0'>{data.requisition_stats?.pending || 0}</h4>
                                </div>
                            </div>
                            <div className="col-6 col-sm-3">
                                <div className='border border-primary rounded p-2 text-center '>
                                    <span className="text-primary fs-6 mb-0"><i className="fa-solid fa-list-check me-2"></i>Partially Fulfilled</span>
                                    <h4 className='text-primary mb-0'>{data.requisition_stats?.partially_fulfilled || 0}</h4>
                                </div>
                            </div>
                            <div className="col-6 col-sm-3">
                                <div className='border border-success rounded p-2 text-center '>
                                    <span className="text-success fs-6 mb-0"><i className="fa-regular fa-circle-check me-2"></i>Fulfilled</span>
                                    <h4 className='text-success mb-0'>{data.requisition_stats?.fulfilled || 0}</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>

};

const PerishableLineChart = ({ perishableStock }) => {

    const perishableSeries = [{ name: 'Stcoks', data: perishableStock?.stock || [] }]
    const perishableLabels = perishableStock?.dates || []
    const perishableOptions = {

        chart: {
            height: 200,
            type: 'line',
            stacked: false,
            toolbar: {
                show: false,
            },
        },
        stroke: {
            curve: 'straight',
            width: 2,
        },
        legend: {
            fontSize: '13px',
            fontFamily: 'poppins',
            labels: {
                colors: '#888888',
            }
        },
        plotOptions: {
            bar: {
                columnWidth: '30%',
                borderRadius: 6,
                dataLabels: {
                    position: 'top', // top, center, bottom
                },
            }
        },
        colors: ["#00B4EB"],
        xaxis: {
            categories: perishableLabels,
            type: 'month',
            labels: {
                style: {
                    fontSize: '8px',
                    colors: '#888888',
                },
            },
        },
        yaxis: {
            min: 0,
            tickAmount: 4,
            labels: {
                style: {
                    fontSize: '13px',
                    colors: '#888888',
                },
            },
        },
        tooltip: {
            shared: true,
            intersect: false,
            y: {
                formatter: function (y) {
                    if (typeof y !== "undefined") {
                        return y.toFixed(0) + " Stocks";
                    }
                    return y;
                }
            }
        }
    }

    return (
        <ReactApexChart
            options={perishableOptions}
            series={perishableSeries}
            type="line"
            height={160}
        />
    )
}

export default CardWidget;